import { render, staticRenderFns } from "./Waypoints.vue?vue&type=template&id=1586ce63&"
import script from "./Waypoints.vue?vue&type=script&lang=js&"
export * from "./Waypoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports